var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftCloseBarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 100,
    viewBox: "0 0 26 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16C21.5228 0 26 4.47715 26 10V90C26 95.5228 21.5228 100 16 100H0V0Z",
    fill: "#E8F9D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.222 42.1141C12.3712 42.1141 12.5205 42.1679 12.634 42.2813L20.8149 50.1278C20.9313 50.2413 21 50.3966 21 50.5578C21 50.719 20.9343 50.8773 20.8149 50.9877L12.634 58.8342C12.3951 59.0612 12.0189 59.0552 11.789 58.8163C11.5621 58.5775 11.5681 58.2013 11.8069 57.9714L19.54 50.5548L11.8069 43.1383C11.5681 42.9113 11.5621 42.5322 11.789 42.2933C11.9055 42.1709 12.0637 42.1082 12.219 42.1082L12.222 42.1141Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.96365 42.1142C6.11294 42.1142 6.26222 42.168 6.37568 42.2814L14.5566 50.1279C14.673 50.2414 14.7417 50.3966 14.7417 50.5579C14.7417 50.7191 14.676 50.8773 14.5566 50.9878L6.37568 58.8343C6.13682 59.0612 5.76062 59.0552 5.53072 58.8164C5.30381 58.5775 5.30978 58.2013 5.54863 57.9714L13.2817 50.5549L5.54863 43.1383C5.30977 42.9114 5.3038 42.5322 5.53072 42.2934C5.64716 42.1709 5.80541 42.1082 5.96066 42.1082L5.96365 42.1142Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftCloseBarIcon);
export default __webpack_public_path__ + "static/media/leftCloseBarIcon.bb188e8fa7924a16ca61598da271cdc4.svg";
export { ForwardRef as ReactComponent };